<template>
    <div>
        <div class="modal fade" id="compartilharRelatorioModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Compartilhar</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    v-model="assunto"
                                    label="Assunto"
                                    placeholder="Informar..."
                                    required
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    v-model="conteudo"
                                    label="Texto"
                                    placeholder="Informar..."
                                    type="textarea"
                                    :validate="validate" />
                            </div>
                        </div>


                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    v-model="destino"
                                    label="E-mail do Destinatário"
                                    placeholder="Informar..."
                                    required
                                    :validate="validate" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    v-model="cc"
                                    label="Com Cópia (CC)"
                                    placeholder="Informar..."
                                    :validate="validate" />                                   
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    v-model="bcc"
                                    label="Com Cópia Oculta (BCC)"
                                    placeholder="Informar..."
                                    :validate="validate" />
                            </div>
                        </div>

                        <template v-if="false">
                            <span v-html="conteudo"></span>
                            <pre>{{ conteudo }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="enviar()">Enviar</az-submit>
                    </div>
                </div>
            </div>
        </div>        
    </div>
</template>

<script>
// import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            destino: "", 
            validate: false, 
            conteudo: "",
            relatorio: "",  
            assunto: "", 
            cc: "",
            bcc: "",
            html: null, 
        };
    },

    components: {
        AzInput,
        AzSubmit,
    },

    methods: {

        abrir(id, parms, html = null) { 
            this.id = id;
            this.parms = parms;
            this.validate = false;
            this.html = html;

            $('#compartilharRelatorioModal').modal('show');
        }, 

        enviar() { 

            this.$util.atualizar(this, {
                service: 'relatorios',
                func: 'compartilhar',
                dados: {
                    id: this.id,
                    filtros: this.parms,
                    assunto: this.assunto, 
                    destino: this.destino,
                    conteudo: this.conteudo,
                    cc: this.cc,
                    bcc: this.bcc,
                    html: this.html, 
                },
                modal: 'compartilharRelatorioModal',
                toast: true,
            });

        }

    }

}
</script>